module.exports = __webpack_public_path__ + "static/media/stopBtn.242c5240.svg";